import CoverageTrendsTab from './CoverageTrendsTab'

export default CoverageTrendsTab
